import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export type BadgeSize = 'default' | 'large' | 'small';

export type BadgeBackgroundColor = 'system-red' | 'system-red-light' | 'system-green-light';

export type BadgeFontColor = 'white' | 'primary';

@Component({
  selector: 'app-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,  
  imports: [
    CommonModule
  ]
})
export class BadgeComponent {
  @Input() size: BadgeSize = 'default';
  @Input() backgroundColor: BadgeBackgroundColor = 'system-red';
  @Input() badgeFontColor: BadgeFontColor = 'white';

  get ngClass(): string[] {
    const classes: string[] = [];
    classes.push('background-' + this.backgroundColor);
    classes.push('font-' + this.badgeFontColor);
    classes.push('size-' + this.size);
    return classes;
  }
}
